import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvestorTaxIdDoesNotMatchWithTaxSystem extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor Tax Id Does Not Match With The Tax System', options);
    }
}
export default InvestorTaxIdDoesNotMatchWithTaxSystem;
